﻿import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from "react-router-dom";
import CreateCalculatorComponent from './Calculators/CreateCalculatorComponent';
import { ProductBatchListItem } from '../models/product-batch-list-item';
import { BenchSheetListItem } from '../models/bench-sheet-list-item';
import { QueryParameters } from '../utilities/query-parameters';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { Calculator } from '../models/Calculators/calculator';
import { ModalMetadata } from '../models/modal-metadata';
import { CalculatorTypes, ModalMessageType } from '../models/enums';

import DataGrid, {
    Column,
    Selection,
    HeaderFilter,
    Toolbar,
    Item as ToolbarItem,
    LoadPanel,
    Button as ColumnButton
} from 'devextreme-react/data-grid';

import { TextBox } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { Template } from 'devextreme-react/core/template';
import { Toast } from 'devextreme-react/toast';
import { Popup as DialogPopup } from 'devextreme-react/popup';

let key = 0;

export default function CalculatorLauncherForm() {
    const navigate = useNavigate();

    const [batches, setBatches] =
        useState<ProductBatchListItem[]>();

    const [selectedBatch, setSelectedBatch] =
        useState<ProductBatchListItem>();

    const [batchFilterString, setBatchFilterString] =
        useState<string>();

    const [calculators, setCalculators] =
        useState<Calculator[]>();

   // const [createCalculatorDialogVisible, setCreateCalculatorDialogVisible] =
     //   useState<boolean>();


    const [createCalculatorDialogVisible, setCreateCalculatorDialogVisible] =
        useState<boolean>();

        /*
    const [createQnmrCalculatorDialogVisible, setCreateQnmrCalculatorDialogVisible] =
        useState<boolean>();

    const [createHplcMassSpecCalculatorDialogVisible, setCreateHplcMassSpecCalculatorDialogVisible] =
        useState<boolean>();
        */

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getCalculatorsList();
    }, [selectedBatch]);

    key++;

    return (
        <div className="pw-form-container">
            <div className="pw-container">
                <div className="lq-title-bar">
                    <div className="lq-main-title">Calculator Launcher</div>
                    <div className="title-bar-spacer" />
                    <div className="save-toolbar">
                        <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                            hint="go back"
                            height={'2.6em'}
                            onClick={goBack} />
                    </div>
                </div>

                <div className="pw-60-40-column-grid">
                    <div id="bs-batch-search">
                        <DataGrid
                            height="35em"
                            keyExpr="batchId"
                            wordWrapEnabled={true}
                            rowAlternationEnabled={true}
                            onSelectionChanged={searchResultsSelectionChanged}
                            dataSource={batches ? batches : []}
                            showBorders={true}>

                            <LoadPanel enabled={true} />
                            <Selection mode='single' />
                            <HeaderFilter visible={true} />

                            <Column dataField='batchName' width='50%' />
                            <Column dataField='catalogNumber' width='50%' />

                            <Toolbar>
                                <ToolbarItem location='before'>
                                    <div className="pw-datagrid-toolbar-template">
                                        <div className="pw-datagrid-toobar-title">Batches</div>
                                    </div>
                                </ToolbarItem>
                                <ToolbarItem location='after' template='searchTemplate' />

                                <ToolbarItem location='after'>
                                    <Button type='success' text='Search' icon='find'
                                        hint='Search for matching Bench Sheets'
                                        width={'9em'}
                                        onClick={onSearchButtonClicked} />
                                </ToolbarItem>
                            </Toolbar>

                            <Template name="searchTemplate" render={searchTemplateRender} />

                        </DataGrid>
                    </div>

                    <div id="bs-calculators">
                        <DataGrid
                            height="35em"
                            width="100%"
                            keyExpr="calculatorId"
                            wordWrapEnabled={true}
                            rowAlternationEnabled={true}
                            onRowDblClick={onCalculatorsDatagridRowDoubleClick}
                            dataSource={calculators ? calculators : []}
                            showBorders={true}>

                            <LoadPanel enabled={true} />
                            <Selection mode='single' />
                            <HeaderFilter visible={true} />

                            <Column width='2.5rem' cellRender={gotoCalculatorColumnButtonRender} alignment='center' />
                            <Column dataField='calculatorTypeDescription' caption="Type" width='20%' dataType="string" />
                            <Column dataField='analysisType' width='30%' dataType="string" />
                            <Column dataField='methodName' width='30%' dataType="string" />

                            <Toolbar>
                                <ToolbarItem location='before'>
                                    <div className="pw-datagrid-toolbar-template">
                                        <div className="pw-datagrid-toobar-title">Calculators</div>
                                    </div>
                                </ToolbarItem>

                                <ToolbarItem location='after'>
                                    <Button id="createCalculatorButton" text="Create New Calculator" icon="add" type="success"
                                        hint="create new calculator"
                                        disabled={!selectedBatch}
                                        height='1.6rem' width='12rem'
                                        onClick={onCreateNewCalculatorClick} />
                                </ToolbarItem>
                            </Toolbar>

                        </DataGrid>
                    </div>
                </div>
            </div>

            {createCalculatorDialogVisible &&
                <DialogPopup visible={createCalculatorDialogVisible}
                    onHiding={hideCreateCalculatorDialog}
                    title="Create New Calculator"
                    width='50rem'
                    height='45rem'
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <CreateCalculatorComponent batch={ selectedBatch } 
                        onClose={onCreateNewCalculatorClose} onCancel={hideCreateCalculatorDialog}
                        key={`CQCC${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );


    function onCreateNewCalculatorClick() {
        //todo

        setCreateCalculatorDialogVisible(true);
    }

    function onSearchButtonClicked() {
        if (batchFilterString)
            getBatchesList(batchFilterString);
    }

    function onCalculatorsDatagridRowDoubleClick(e: any) {
        if (e.data) {
            let calc = e.data as Calculator;

            if (calc && calc.calculatorType && calc.calculatorId) {
                let path;

                switch (calc.calculatorType) {
                    case CalculatorTypes.MultiComponentMasterAssay:
                        break;

                    case CalculatorTypes.Neat:
                        break;

                    case CalculatorTypes.Qnmr:
                        path = `/qnmr-calculator/${calc.calculatorId}`;
                        break;

                    case CalculatorTypes.HplcMassSpec:
                        path = `/hplc-mass-spec-calculator/${calc.calculatorId}`;
                        break;
                }

                if (path)
                    navigate(path);

            }
        }
    }

    function searchResultsSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0 &&
            e.selectedRowsData[0].batchId) {
            setSelectedBatch(e.selectedRowsData[0]);
        }
    }

    function batchFilterChanged(e: any) {
        setBatchFilterString(e.value);
    }

    // crud functions

    async function getBatchesList(filter: string) {
        if (filter) {
            await CrudFunctions.getData(`products/batchesbypartnumberbatchname/${filter}`)
                .then((data) => {
                    setBatches(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Batches");
                });
        }
    }

    async function getCalculatorsList() {
        if (selectedBatch && selectedBatch.batchId) {
            await CrudFunctions.getData(`calculator/calculators/${selectedBatch.batchId}`)
                .then((data) => {
                    setCalculators(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Calculators");
                });
        }
    }

    //navigate

    function goBack() {
        history.back();
    }

    //render

    function gotoCalculatorColumnButtonRender(e: any) {
        let calc = e.data as Calculator;

        if (!calc) 
            return <div></div>;
        
        let path;

        switch (calc.calculatorType) {
            case CalculatorTypes.MultiComponentMasterAssay:
                path = `/masterassaycalculator/${calc.batchId}`;
                break;

            case CalculatorTypes.Qnmr:
                path = `/qnmr-calculator/${calc.calculatorId}`;
                break;
        
            case CalculatorTypes.HplcMassSpec:
                path = `/hplc-mass-spec-calculator/${calc.calculatorId}`;
                break;

            default:
                return <div></div>;
        }

        return <NavLink to={path} className="datagrid-icon-link"><span className="dx-icon-formula datagrid-icon"></span></NavLink>
    }

    function searchTemplateRender(e: any) {
        return (
            <div className="pw-datagrid-toolbar-template">
                <TextBox id="txtSearch" className="pw-datagrid-toobar-textbox"
                    placeholder="search"
                    hint="search by batch"
                    value={batchFilterString}
                    onValueChanged={batchFilterChanged}
                    onEnterKey={onSearchButtonClicked} />
            </div>
        );
    }

    function onCreateNewCalculatorClose() {
        getCalculatorsList();
        setCreateCalculatorDialogVisible(false);
    }

    function hideCreateCalculatorDialog() {
       setCreateCalculatorDialogVisible(false);
    }    

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}
